import {BusinessPinResetRequestStatus} from '@/types';

/** Badge colours for a request's state: amber pending, green approved, red declined. */
export const pinResetStatusColorScheme = (
  status: BusinessPinResetRequestStatus,
): string => {
  switch (status) {
    case BusinessPinResetRequestStatus.Approved:
      return 'bg-green-100 text-green-700';
    case BusinessPinResetRequestStatus.Rejected:
      return 'bg-red-100 text-red-700';
    case BusinessPinResetRequestStatus.Expired:
      return 'bg-gray-100 text-gray-600';
    case BusinessPinResetRequestStatus.Pending:
    default:
      return 'bg-yellow-100 text-yellow-800';
  }
};
